import { extends as _extends, objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useMemo } from 'react';
import { bool } from '../../../utils/styled-props.esm.js';
import { BoxPrivate } from '../box/box.esm.js';

var _excluded = ["__css", "display", "inline"];
var flexDirection = bool('flexDirection', ['row', 'column', 'rowReverse', 'columnReverse'], true);
// typechecking causes error TS2590: Expression produces a union type that is too complex to represent.
var FlexPrivate = /*#__PURE__*/React.forwardRef(function FlexPrivate(props, ref) {
  var _useMemo = useMemo(function () {
      var __css = props.__css,
        display = props.display,
        inline = props.inline,
        rest = _objectWithoutProperties(props, _excluded);
      return {
        __css: __css,
        displayProps: display,
        inline: inline,
        rest: rest
      };
    }, [props]),
    __css = _useMemo.__css,
    displayProps = _useMemo.displayProps,
    inline = _useMemo.inline,
    rest = _useMemo.rest;
  var baseStyles = useMemo(function () {
    return _objectSpread2(_objectSpread2({
      display: displayProps ? displayProps : inline ? 'inline-flex' : 'flex'
    }, __css), flexDirection(rest));
  }, [__css, displayProps, inline, rest]);
  return /*#__PURE__*/React.createElement(BoxPrivate, _extends({
    ref: ref
  }, rest, {
    __css: baseStyles
  }));
});
var Flex = /*#__PURE__*/React.forwardRef(function Flex(props, ref) {
  return /*#__PURE__*/React.createElement(FlexPrivate, _extends({
    ref: ref
  }, props));
});

export default Flex;
export { FlexPrivate };
//# sourceMappingURL=flex.esm.js.map
